export default __webpack_public_path__ + "media/images/brands/demo/services/service-02-fb15a38bacbdc6755b04bbdc1e0c610f.jpg";